module.exports = __webpack_public_path__ + "static/media/1.3023bd86.png";